export const Spacing = {
  actions: 12,
  px4: 4,
  px8: 8,
  px12: 12,
  px18: 18,
  px24: 24,
  px32: 32,
  px48: 48,
  px64: 64,
};
